import { useEffect, useState } from "react";
import { ALL_ITEMS } from "./nav";

/**
 * 没带 hash 时落在哪一页。
 *
 * 是「初始化配置」而不是「总造价配置」：新代理一进来什么配置都没有，落在造价页
 * 只会看到「该代理还没有配置」；而真正该先做的事——选玩法体系与建筑体系——在初始化页，
 * 且这两项决定左边显示哪一组页面。老代理照样能从菜单点走，代价只是多一次点击。
 */
const DEFAULT_PAGE = "init-config";
const known = (id: string) => ALL_ITEMS.some((i) => i.id === id);
/** 并掉的页：旧链接（收藏、聊天记录里的）跳到新家，不落回首页 */
const MOVED: Record<string, string> = {
  // 2026-10-23 超管管理并进账号管理
  "super-admins": "accounts",
};
/**
 * hash 里 / 后面那段是页内定位（如 `#help-videos/cost` = 课程中心的「总造价」分区），由页面自己读；
 * 路由只认 / 前面的页面 id
 */
const pageOf = (hash: string) => { const id = hash.slice(1).split("/")[0]; return MOVED[id] ?? id; };

/**
 * hash 路由。用 hash 而不是 history API：配置台是纯静态资源部署，
 * history 路由要 Worker 侧把所有路径回落到 index.html，多一处能配错的地方。
 */
export function useHashRoute(): [string, (id: string) => void] {
  const [page, setPage] = useState(() => {
    const h = pageOf(location.hash);
    return known(h) ? h : DEFAULT_PAGE;
  });
  useEffect(() => {
    const onHash = () => {
      const h = pageOf(location.hash);
      if (known(h)) setPage(h);
    };
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);
  const go = (id: string) => {
    location.hash = id;
    setPage(id);
  };
  return [page, go];
}
